import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import { Header } from './header';
import { ReelsTab } from './tabs';
import { Timeline } from './timeline';
import { ReelsProvider } from '../../../contexts/reels';
import { NotificationProvider } from '../../../contexts/notification';

const LoadingDraft: React.FC = () => {
  return (
    <div
      className={
        'd-flex flex-column gap-3 align-items-center justify-content-center'
      }
      style={{
        height: '100vh',
        width: '100vw'
      }}>
      <span className={'loader'} role="status"></span>
      Load reels draft
    </div>
  );
};

export const ReelsPage: React.FC = () => {
  const { gameCode } = useParams();

  return (
    <Suspense fallback={<LoadingDraft />}>
      <ReelsProvider gameCode={gameCode ?? ''}>
        <NotificationProvider>
          <div
            className={'d-flex flex-column overflow-hidden'}
            style={{
              height: '100vh'
            }}>
            <Header />

            <div
              className={'d-flex flex-column flex-grow-1 overflow-hidden'}
              style={{
                padding: '24px 40px',
                gap: '24px',
                backgroundColor: '#F8FCFE'
              }}>
              <Timeline />
              <ReelsTab />
            </div>
          </div>
        </NotificationProvider>
      </ReelsProvider>
    </Suspense>
  );
};
